import React from "react"

export default React.createContext({ loading: false, setLoading: () => null, addressesLoading: false, setAddressesLoading: () => null })
